const divFormService = {
  inspectedBy: 'inspected by:',
  itemLabel: 'Local',
  equipment: 'Equipment',
  serialNumber: 'S/N:',
  reference: 'Reference point:',
  description: 'Equipment description:',
  fileStillUploading: 'Wait for all files to upload',
  fileError: 'There are submitted files with error',
  equipmentModelDescription: 'Equipment Type description: '
};

export default divFormService;
